import { render, staticRenderFns } from "./terUserMenuAction.vue?vue&type=template&id=42ff94e8"
import script from "./terUserMenuAction.vue?vue&type=script&lang=js"
export * from "./terUserMenuAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports